var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApartments1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4759 11.7071C2.18016 11.8891 2 12.2115 2 12.5588V21C2 21.5523 2.44772 22 3 22H6V18.5C6 17.1193 7.11929 16 8.5 16C9.88071 16 11 17.1193 11 18.5V22H14C14.5523 22 15 21.5523 15 21V12.5588C15 12.2115 14.8198 11.8891 14.5241 11.7071L9.5482 8.64507C8.90538 8.24949 8.09462 8.24949 7.45181 8.64507L2.4759 11.7071Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4C8 2.89543 8.89543 2 10 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H16.292C16.4258 21.6938 16.5 21.3556 16.5 21V12.5588C16.5 11.868 16.2148 11.2166 15.7258 10.75H17.5C17.9142 10.75 18.25 10.4142 18.25 10C18.25 9.58579 17.9142 9.25 17.5 9.25H13.3933L10.3343 7.36758C9.62408 6.9305 8.79664 6.76938 8 6.88424V4ZM11.75 6C11.75 6.41421 12.0858 6.75 12.5 6.75H17.5C17.9142 6.75 18.25 6.41421 18.25 6C18.25 5.58579 17.9142 5.25 17.5 5.25H12.5C12.0858 5.25 11.75 5.58579 11.75 6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartments1);
export default __webpack_public_path__ + "static/media/apartments-1.826fd0a27d8c07ac9ed9f81080a6d1ed.svg";
export { ForwardRef as ReactComponent };